import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoComponent } from './demo/demo.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[DemoComponent],
  declarations: [DemoComponent]
})
export class DemoModule { }



// WEBPACK FOOTER //
// ./src/app/component/demo/demo.module.ts